const BASE = '/api';

async function request(path, { method = 'GET', body, headers } = {}) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    body: body ? JSON.stringify(body) : undefined
  });
  const contentType = res.headers.get('content-type') ?? '';
  const data = contentType.includes('application/json') ? await res.json() : await res.text();
  if (!res.ok) {
    // Broadcast 401s so AuthProvider can clear the user and AppLayout can
    // redirect to /login. Guarded against the auth probe itself (GET /auth/me)
    // which is expected to 401 before login — otherwise the initial page load
    // would show a spurious redirect flash.
    if (res.status === 401 && !(method === 'GET' && path === '/auth/me')) {
      window.dispatchEvent(new Event('auth:unauthorized'));
    }
    const err = new Error(data?.error ?? res.statusText);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export const api = {
  get: (path, opts) => request(path, { ...opts, method: 'GET' }),
  post: (path, body, opts) => request(path, { ...opts, method: 'POST', body }),
  put: (path, body, opts) => request(path, { ...opts, method: 'PUT', body }),
  patch: (path, body, opts) => request(path, { ...opts, method: 'PATCH', body }),
  delete: (path, opts) => request(path, { ...opts, method: 'DELETE' })
};
